// React imports.
import React from "react";


// App imports.
import Assessment3Sup2TableRow from "./Assessment3Sup2TableRow";

const Assessment3Sup2Table = ({ state }) => (
    <div>
        
        <br />
        <div className="vendorsReportedGrid">
            <div className="header">Main Heating Fuel	</div>
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholds === true &&		
            <div className="header">Total # of Assisted Households	</div>
            }
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsServedByVendorsProvidingData === true &&		
            <div className="header"># of Households Represented by Vendors Providing Data	</div>
            }
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showPercentHouseholdsServedByVendorsProvidingData === true &&		
            <div className="header">% of Total Represented by Vendors Providing Data	</div>
            }		
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showVendorsProvidingDataStatus === true &&		
            <div className="header">Vendors Providng Percent Status	</div>
            }

            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.Electric.name)
                &&
                <Assessment3Sup2TableRow
                    rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.Electric.name )}
                    state={state}
                    fuel={state.Assessment3FuelTypesStatus.Electric} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.NaturalGas.name)
                &&
                <Assessment3Sup2TableRow
                    rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.NaturalGas.name )}
                    state={state}
                    fuel={state.Assessment3FuelTypesStatus.NaturalGas} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.FuelOil.name)
                &&
                <Assessment3Sup2TableRow
                    rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.FuelOil.name )}
                    state={state}
                    fuel={state.Assessment3FuelTypesStatus.FuelOil} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.Propane.name)
                &&
                <Assessment3Sup2TableRow
                    rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.Propane.name )}
                    state={state}
                    fuel={state.Assessment3FuelTypesStatus.Propane} />
            }
        </div>
    </div>
);

export default Assessment3Sup2Table;
